import React from "react";
import CustomModal from "../../../components/Modal/CustomModal";
import CustomGenericTittleIconDataChip from "../../../components/CustomGenericTittleIconDataChip";
import NotInformation from "../../../components/NotInformation";
import ResidentAssignedCard from "../SubComponents/Residents/ResidentAssignedCard";
import CustomChip from "../../../components/CustomChip";
import {colors} from "../../../enums/colors";
import {IconHouseOutlined} from "../../../components/buttons/IconButtons";
import {UnitDetailsModalApp} from "../Functionality/UnitDetailsModalApp";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Read-only details of one unit of the building: the main resident and the rest
 * of the household members, both rendered as resident cards. The residents come
 * from the apartment endpoint, the unit of the list only names the modal.
 *
 * @param {boolean} props.show - Modal visibility.
 * @param {Function} props.onHide - Closes the modal.
 * @param {Object} props.item - Unit shown in the modal.
 */
const UnitDetailsModal = ({
    show,
    onHide,
    item
}) => {
    const {
        t,
        unitDetail,
        loading
    } = UnitDetailsModalApp({ show, apartmentId: item?.id });

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            size={'lg'}
            confirmButton={false}
            cancelButton={false}
            buttonCancelText={'dismiss'}
            topLeftHeader={
                <div className='d-flex align-items-center pb-3'>
                    <div> <IconHouseOutlined /></div>
                    <p className='fs-24px ibl-font-w-600  font-color-general-950 font-color-primary-600 ml-2'>
                        {`${t("apartment")} ${item?.name || unitDetail?.apartment || ''}`}
                    </p>
                    <div className='vertical-separator h-auto' />
                </div>
            }
        >
            <div className={"row border-full-shades-300 border-radius-8px p-16px"}>
                <CustomGenericTittleIconDataChip
                    title={'main_resident'}
                    showAvatar={false}
                    className={'px-0'}
                />

                { unitDetail?.mainResident ?
                    <div className={"col-12 col-md-6 my-3 px-1"}>
                        <ResidentAssignedCard
                            keyId={'id'}
                            item={unitDetail.mainResident}

                        />
                    </div>
                    : !loading &&
                    <div className={"my-3 px-1"}><NotInformation text={t('no_main_resident_linked_yet')} card={true}/></div>
                }

                <CustomGenericTittleIconDataChip
                    title={'household_members'}
                    showAvatar={false}
                    className={'px-0'}
                    badge={
                        <CustomChip
                            background={colors.shades200}
                            fontColor={colors.shades500}
                            borderColor={colors.shades300}
                            legend={unitDetail?.members?.length ?? 0}
                            variant='compact'
                        />
                    }
                />

                <div className={"row mt-3 px-0"}>
                    { unitDetail?.members?.length > 0 ?
                        unitDetail.members.map((member) => (
                            <div className={"col-12 col-md-6 mb-3 px-1"} key={member?.id}>
                                <ResidentAssignedCard
                                    keyId={'id'}
                                    item={member}
                                />
                            </div>
                        ))
                        : !loading && <NotInformation text={t('no_additional_household_members')} card={true}/>
                    }
                </div>
            </div>
        </CustomModal>
    );
};

export default UnitDetailsModal;
